// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import media from '../../../helpers/media';
import type { Nav } from '../../../types/apiRoute';
import ElementGenerator from './elementGenerator';
import type { Theme } from '../../../types';

type Props = {
  nav: Nav,
};

const StyleWrapper = styled<any, Theme>('div')`
  display: none;
  ${media.md(css`
    display: block;
  `)}
  padding: 1rem 0;
  ul {
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }
  a {
    color: ${props => props.theme.menu.footer.linkColor};
    text-decoration: none;
    &:hover,
    &.active {
      color: ${props => props.theme.menu.footer.linkActiveColor};
    }
  }
  .level-0 {
    display: flex;
    flex-wrap: wrap;

    > li {
      flex: 1;
      padding: 1rem 0;
      flex-basis: 50%;
      ${media.lg(css`
        flex-basis: auto;
      `)}
      > .link {
        font-size: 1.125rem;
        font-weight: bold;
      }
    }
  }
  .level-1 {
    margin-top: 1rem;
    li {
      .link {
        .link-title {
          display: block;
          padding: .4rem 0;
        }
      }
    }
  }
`;

export default ({ nav }: Props) => (
  <StyleWrapper>
    <ElementGenerator nav={nav} />
  </StyleWrapper>
);
